import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function HomeRedirect() {
  const { activePortal } = useAuth();
  
  if (activePortal === 'vendor') {
    return <Navigate to="/vendor/dashboard" replace />;
  }
  
  return <Navigate to="/dashboard" replace />;
}
